import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Dimmer, Icon, Label, Loader, Table } from 'semantic-ui-react';
import store from '../../../store';
import { formatDateTime } from '../../../utils/shared.utils';
import './warehouse.admin.scss';

const ORDER_STATUS_LABEL: Record<string, { color: string; text: string }> = {
    CONFIRMED: { color: 'green', text: 'Баталгаажсан' },
    PLACED:    { color: 'blue',  text: 'Хүлээгдэж буй' },
    // ARCHIVED:  { color: 'grey',  text: 'Цуцлагдсан' },
};

export default function AdminWarehouseImportHistoryPageComponent(props: any) {
    const history = useHistory();
    const id = props.match.params.id;
    const importId = props.match.params.importId;

    const [importInfo, setImportInfo] = useState<any>(null);
    const [minusHistory, setMinusHistory] = useState<any[]>([]);
    const [orderSales, setOrderSales] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('adminToken');
        if (!token || token === 'undefined') {
            store.dispatch({ type: 'redirectUrl', data: window.location.pathname });
            history.push('/');
            return;
        }
        setLoading(true);
        fetch(process.env.REACT_APP_API_URL + 'mongol/warehouse/' + id + '/import/' + importId + '/decrease-history', {
            method: 'GET',
            headers: { Accept: 'application/json', Authorization: token, 'Content-Type': 'application/json' },
        })
            .then((r) => (r.ok ? r.json() : Promise.reject()))
            .then((data) => {
                setImportInfo(data?.importInfo || null);
                setMinusHistory(Array.isArray(data?.minusHistory) ? data.minusHistory : []);
                setOrderSales(Array.isArray(data?.orderSales) ? data.orderSales : []);
            })
            .catch(() => {
                setMinusHistory([]);
                setOrderSales([]);
            })
            .finally(() => setLoading(false));
    }, [id, importId, history]);

    return (
        <div className="page-admin">
            <section className="admin-warehouse-form">
                <Dimmer active={loading}>
                    <Loader size="medium" />
                </Dimmer>
                <a onClick={() => history.goBack()}>
                    <Icon name="angle left" />
                    <span className="underline">Буцах</span>
                </a>
                <div className="width-100 text-center">
                    <h1>Өртөг #{importId} – Хасагдсан болон борлуулсан түүх</h1>
                </div>
             
                <h2>Эхний үлдэгдэл: {importInfo?.originalCount ?? '–'}</h2>
                <br />

                <h3 className="margin-top-0">Админ хассан түүх:</h3>
                <Table striped className="admin-list-table" width={16}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Хасагдсан тоо</Table.HeaderCell>
                            <Table.HeaderCell>Өртгийн үлдэгдэл</Table.HeaderCell>
                            <Table.HeaderCell>Тайлбар</Table.HeaderCell>
                            <Table.HeaderCell>Хэрэглэгч</Table.HeaderCell>
                            <Table.HeaderCell>Огноо</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {minusHistory.length === 0 ? (
                            <Table.Row>
                                <Table.Cell colSpan={5} data-label="Мэдээлэл">Хасагдсан түүх олдсонгүй.</Table.Cell>
                            </Table.Row>
                        ) : (
                            minusHistory.map((row: any) => (
                                <Table.Row key={'mh-' + row.id}>
                                    <Table.Cell data-label="Хасагдсан тоо">{row.minusCount ?? '–'}</Table.Cell>
                                    <Table.Cell data-label="Өртгийн үлдэгдэл">{row.warehouseImportCount ?? '–'}</Table.Cell>
                                    <Table.Cell data-label="Тайлбар">{row.note || '–'}</Table.Cell>
                                    <Table.Cell data-label="Хэрэглэгч">{row.createdBy || '–'}</Table.Cell>
                                    <Table.Cell data-label="Огноо">{row.createdAt ? formatDateTime(new Date(row.createdAt)) : '–'}</Table.Cell>
                                </Table.Row>
                            ))
                        )}
                    </Table.Body>
                </Table>
                <h4>Нийт хасагдсан: {minusHistory.reduce((acc: number, row: any) => acc + (row.minusCount ?? 0), 0)}</h4>

                <br/>
                <h3>Захиалгаар борлуулсан түүх:</h3>
                <Table striped className="admin-list-table" width={16}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Тоо</Table.HeaderCell>
                            <Table.HeaderCell>Захиалга</Table.HeaderCell>
                            <Table.HeaderCell>Төлөв</Table.HeaderCell>
                            <Table.HeaderCell>Огноо</Table.HeaderCell>
                            <Table.HeaderCell>Хэрэглэгч</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {orderSales.length === 0 ? (
                            <Table.Row>
                                <Table.Cell colSpan={5} data-label="Мэдээлэл">Захиалгаар борлуулалт олдсонгүй.</Table.Cell>
                            </Table.Row>
                        ) : (
                            orderSales.map((row: any) => {
                                const statusInfo = ORDER_STATUS_LABEL[row.orderStatus];
                                return (
                                    <Table.Row key={'os-' + row.id}>
                                        <Table.Cell data-label="Тоо">{row.count ?? '–'}</Table.Cell>
                                        <Table.Cell data-label="Захиалга">
                                            {row.orderToken ? (
                                                <Link to={'/mongol/report/order/' + row.orderId} target="_blank">
                                                    #{row.orderToken}
                                                </Link>
                                            ) : row.orderId ? (
                                                <Link to={'/mongol/report/order/' + row.orderId}>Order #{row.orderId}</Link>
                                            ) : (
                                                '–'
                                            )}
                                        </Table.Cell>
                                        <Table.Cell data-label="Төлөв">
                                            {statusInfo ? (
                                                <Label color={statusInfo.color as any} size="small">{statusInfo.text}</Label>
                                            ) : (
                                                row.orderStatus || '–'
                                            )}
                                        </Table.Cell>
                                        <Table.Cell data-label="Огноо">{row.createdAt ? formatDateTime(new Date(row.createdAt)) : '–'}</Table.Cell>
                                        <Table.Cell data-label="Хэрэглэгч">{row.createdBy || '–'}</Table.Cell>
                                    </Table.Row>
                                );
                            })
                        )}
                    </Table.Body>
                </Table>
                <h4>Нийт борлуулалт: {orderSales.reduce((acc: number, row: any) => acc + (row.count ?? 0), 0)}</h4>

            </section>
        </div>
    );
}
